<template>
    <div>

        <div class="position-relative">

            <section class="section-shaped my-0">
                <div class="shape shape-style-1 shape-default shape-skew">
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                <div class="container shape-container d-flex">
                    <div class="col px-0">
                        <div class="row">
                            <div class="col-lg-6">
                                <h1 class="display-3  text-white mb-5" >
					Transform your business 		
                                    <span>with our IT development, management and support services</span>
                                </h1>
                                <div class="btn-wrapper">
                                    <base-button tag="a" v-if="''"
                                                 href="#"
                                                 class="mb-3 mb-sm-0"
                                                 type="info"
                                                 icon="ni ni-album-2">
                                        Watch video
                                    </base-button>
                                    <base-button tag="a"
                                                 href="#/contact"
                                                 class="mb-3 mb-sm-0"
                                                 type="white"
                                                 icon="ni ni-email-83">
                                        Get in touch
                                    </base-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </div>
        <section class="section section-lg pt-lg-0 mt--200">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-12">
                        <div class="row row-grid">
                            <div class="col-lg-4">
                                <card class="border-0" hover shadow body-classes="py-5">
                                    <icon name="ni ni-archive-2" type="primary" rounded class="mb-4">
                                    </icon>
                                    <h6 class="text-primary text-uppercase">App Development</h6>
                                    <p class="description mt-3">
					We offer a full spectrum of software development services 
					from project planning to its implementation into your 
					data centre or cloud environment. Team extension 
					cooperation model assures smooth communication, 
					fast reaction to changing circumstances and 
					high-quality product.
				    </p>
                                    <div>
                                        <badge type="primary" rounded>Extendable</badge>
                                        <badge type="primary" rounded>Quality</badge>
                                        <badge type="primary" rounded>Efficient</badge>
                                    </div>
                                    <base-button tag="a" href="#/team_extension" type="primary" class="mt-4">
                                        Learn more
                                    </base-button>
                                </card>
                            </div>
                            <div class="col-lg-4">
                                <card class="border-0" hover shadow body-classes="py-5">
                                    <icon name="ni ni-atom" type="success" rounded class="mb-4">
                                    </icon>
                                    <h6 class="text-success text-uppercase">Smart Technologies</h6>
                                    <p class="description mt-3">
						We offer advice, support and implementation services on technologies 
						<ul>
						<li>
						from Deep Learning to Genetic Algorithms, 
						</li>
						<li>
						from Blockchains to transaction securing mechanisms, 
						</li>
						<li>
						from Process Mining to Data Analytics.
						</li></ul>
					</p>
                                    <div>
                                        <badge type="success" rounded>Deep Learning</badge>
                                        <badge type="success" rounded>Blockchain</badge>
                                        <badge type="success" rounded>Data</badge>
                                    </div>
                                    <base-button tag="a" href="#/intelligent_apps" type="success" class="mt-4">
                                        Learn more
                                    </base-button>
                                </card>
                            </div>
                            <div class="col-lg-4">
                                <card class="border-0" hover shadow body-classes="py-5">
                                    <icon name="ni ni-settings" type="warning" rounded class="mb-4">
                                    </icon>
                                    <h6 class="text-warning text-uppercase">Support and Maintenance</h6>
				    <p class="description mt-3">
					Cost-effective maintenance and support solutions designed to help you with 
					system monitoring, application updates and deployments, 24/7 emergency 
					service, user activity monitoring, resource management, services that 
					ensure your applications work well for your customers.
					</p>
                                    <div>
                                        <badge type="warning" rounded>Deployment</badge>
                                        <badge type="warning" rounded>Monitoring</badge>
                                        <badge type="warning" rounded>24/7 support</badge>
                                    </div>
                                    <base-button tag="a" href="#/maintenance_and_support" type="warning" class="mt-4">
                                        Learn more
                                    </base-button>
                                </card>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="section section-lg">
            <div class="container">
                <div class="row row-grid align-items-center">
                    <div class="col-md-6 order-md-2">


<div class="table-responsive">
    <table class="table table-bordered">
      <thead class="bg-warning">
        <tr>
          <th></th>
          <th>Team Extension</th>
          <th>Outsourcing</th>
          <th>Insourcing</th>
          <th>Contractors</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Reduce development costs</td>
          <td class="yes">Yes</td>
          <td class="yes">Yes</td>
          <td class="yes">Yes</td>
          <td class="no">No</td>
        </tr>
        <tr>
          <td>Adjust team size when required</td>
          <td class="yes">Yes</td>
          <td class="sometimes">Sometimes</td>
          <td class="no">No</td>
          <td class="no">No</td>
        </tr>
        <tr>
          <td>Part of inhouse team</td>
          <td class="yes">Yes</td>
          <td class="no">No</td>
          <td class="yes">Yes</td>
          <td class="yes">Yes</td>
        </tr>
        <tr>
          <td>Provide project management</td>
          <td class="yes">Yes</td>
          <td class="yes">Yes</td>
          <td class="no">No</td>
          <td class="no">No</td>
        </tr>
      </tbody>
    </table>
  </div>




                    </div>
                    <div class="col-md-6 order-md-1">
                        <div class="pr-md-5">
                            <icon name="ni ni-building" class="mb-5" size="lg" type="success" shadow
                                  rounded></icon>
                            <h3>Team Extension vs Contractors vs Outsourcing</h3>
			    <p>
				Rapidly changing Tech business requires adaptable solutions to deal with 
				fluctuating IT experts demand. To be able to optimize the resources most 
				companies employ external experts. The most popular arrangements when working 
				with external service providers are employing contractors and outsourcing project 
				to the external company. While both of these arrangements have significant 
				disadvantages, we offer Team Extension Model which incorporates both traditional 
				methods to minimize their intrinsic limitations. 	
		            </p>
                            <ul class="list-unstyled mt-5">
                                <li class="py-2">
                                    <div class="d-flex align-items-center">
                                        <badge type="success" circle class="mr-3" icon="ni ni-check-bold"></badge>
                                        <h6 class="mb-0">Inhouse work management team (10%)</h6>
                                    </div>
                                </li>
                                <li class="py-2">
                                    <div class="d-flex align-items-center">
                                        <badge type="success" circle class="mr-3" icon="ni ni-check-bold"></badge>
                                        <h6 class="mb-0">Remote, cost-effective expert team (90%)</h6>
                                    </div>
                                </li>
                                <li class="py-2">
                                    <div class="d-flex align-items-center">
                                        <badge type="success" circle class="mr-3" icon="ni ni-check-bold"></badge>
                                        <h6 class="mb-0">Fully managed projects or just support tasks</h6>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="section bg-secondary">
            <div class="container">
                <div class="row row-grid align-items-center">
                    <div class="col-md-6">
                        <div class="card bg-default shadow border-0">
                            <img v-lazy="'img/theme/technology_everywhere.jpg'" class="card-img-top">
                            <blockquote class="card-blockquote">
                                <svg preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 583 95"
                                     class="svg-bg">
                                    <polygon points="0,52 583,95 0,95" class="fill-default"></polygon>
                                    <polygon points="0,42 583,95 683,0 0,95" opacity=".2" class="fill-default"></polygon>
                                </svg>
                                <h4 class="display-3 font-weight-bold text-white">Technology to win</h4>
                                <p class="lead text-italic text-white">
																		To stay competitive in the current fast-changing market, most companies become tech companies. 
																		And with the new technologies come new opportunities and 
																		new challenges. Make sure you are ready and prepared for the changes 
																		to succeed. 
                                    </p>
                            </blockquote>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="pl-md-5">
                            <icon name="ni ni-ui-04" class="mb-5" size="lg" type="warning" shadow rounded></icon>

                            <h3>Transformational technology</h3>
                            <p class="lead">
				Technologies such as AI, Blockchain, IoT (the Internet of Things) becoming very popular. 
				This is not only because they allow to find the solution to the problems that are difficult 
				to solve otherwise, but mainly because they became very affordable and easy to 
				implement in the past years. 			    
			   </p>
                            <p>	
				Return on investment for the technologies is high, and the most limiting factor, 
				more often than not, is the availability of skilled experts.
			    </p>
			    <p>
				We conduct talent search and recruitment programs as well as cooperate with universities 
				and other academic institutions to get access to the required experts.
			    </p>
                            <a href="#/intelligent_apps" class="font-weight-bold text-warning mt-5">Game-changing technologies</a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="section section section-shaped my-0 overflow-hidden">
            <div class="shape shape-style-1 bg-gradient-warning shape-skew">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
            <div class="container py-0">
                <div class="row row-grid align-items-center">
                    <div class="col-md-6 order-lg-2 ml-lg-auto">
                        <div class="position-relative pl-md-5">
                            <img src="img/ill/ill-2.svg" class="img-center img-fluid">
                        </div>
                    </div>
                    <div class="col-lg-6 order-lg-1">
                        <div class="d-flex px-3">
                            <div>
                                <icon name="ni ni-bulb-61" size="lg" class="bg-gradient-white" color="primary" shadow
                                      rounded></icon>
                            </div>
                            <div class="pl-4">
                                <h4 class="display-3 text-white">Modern tools and Agile methods</h4>
                                <p class="text-white">
					Modern IT tools and Agile development method help to minimize development cost and time as well as to assure high project performance quality.
				</p>
                            </div>
                        </div>
                        <card shadow class="shadow-lg--hover mt-5">
                            <div class="d-flex px-3">
                                <div>
                                    <icon name="ni ni-archive-2" gradient="success" color="white" shadow
                                          rounded></icon>
                                </div>
                                <div class="pl-4">
                                    <h5 class="title text-success">Incremental Development and Continuous Delivery</h5>
                                    <p>
																			<ul>
																				<li>Divide the project into small task modules</li>
																				<li>Distribute the modules to multiple developers</li>
																				<li>Add the built modules into the project</li>
																				<li>Test and continue building</li>
																			</ul>
																		</p>
                                    <a href="#/" class="text-success">Learn more</a>
                                </div>
                            </div>
                        </card>
                        <card shadow class="shadow-lg--hover mt-5">
                            <div class="d-flex px-3">
                                <div>
                                    <icon name="ni ni-box-2" gradient="warning" color="white" shadow
                                          rounded></icon>
                                </div>
                                <div class="pl-4">
                                    <h5 class="title text-warning">Modular, Containerized, Cloud deployed</h5>
                                    <p>
					With the cloud computing era, many applications can be transformed into 
					cloud services, where they can be accessed anytime and anywhere. Cloud 
					technologies can often create new business opportunities in a form of 
					IaaS (Infrastructure as a Service), Paas (Platform as a Service), 
					Saas (Software as a Service).
				    </p>
                                    <a href="#/cloud_computing" class="text-warning">Learn more</a>
                                </div>
                            </div>
                        </card>
                    </div>
                </div>
            </div>
        </section>
        <section v-if="''" class="section section-lg pt-0">
            <div class="container">
                <card gradient="warning"
                      no-body
                      shadow-size="lg"
                      class="border-0">
                    <div class="p-5">
                        <div class="row align-items-center">
                            <div class="col-lg-8">
                                <h3 class="text-white">Appsa Business Partnership Program</h3>
                                <p class="lead text-white mt-3">
					Appsa Business Partnership Program helps our Business Partners to transform
					clients into leading tech companies.
				</p>
                            </div>
                            <div class="col-lg-3 ml-lg-auto">
                                <base-button tag="a" href="#/business_partner"
                                             type="white" block size="lg">
                                   more info 
                                </base-button>
                            </div>
                        </div>
                    </div>
                </card>
            </div>
        </section>
        <section class="section section-shaped my-0 overflow-hidden">
            <div class="shape shape-style-3 bg-gradient-default shape-skew">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
            <div class="container pt-lg pb-300">
                <div class="row text-center justify-content-center">
                    <div class="col-lg-10">
                        <h2 class="display-3 text-white">Let's build something</h2>
                        <p class="lead text-white">
				Can't you find an application for IT technology in your business 
				that would take you to the next level? Let us help you:
			</p>
                    </div>
                </div>
                <div class="row row-grid mt-5">
                    <div class="col-lg-4">
                        <icon name="ni ni-zoom-split-in" size="lg" gradient="white" shadow round color="primary"></icon>
                        <h5 class="text-white mt-3">Find a business case</h5>
                        <p class="text-white mt-3">
				We will analyse your business, find improvement opportunities and propose a solution
			</p>
                    </div>
                    <div class="col-lg-4">
                        <icon name="ni ni-building" size="lg" gradient="white" shadow round color="primary"></icon>
                        <h5 class="text-white mt-3">Build the solution</h5>
                        <p class="text-white mt-3">
				We will build and implement the solution
			</p>
                    </div>
                    <div class="col-lg-4">
                        <icon name="ni ni-money-coins" size="lg" gradient="white" shadow round color="primary"></icon>
                        <h5 class="text-white mt-3">Grow your market</h5>
                        <p class="text-white mt-3">
				You monitor the success and reap the benefits of the project
			</p>
                    </div>
                </div>
            </div>
        </section>
        <section class="section section-lg pt-lg-0 section-contact-us">
            <div class="container">
                <div class="row justify-content-center mt--300">
                    <div class="col-lg-8">
                        <card gradient="secondary" shadow body-classes="p-lg-5">
                            <h4 class="mb-1">Want to work with us?</h4>
                            <p class="mt-0">Your success is important to us.</p>
                            <base-input class="mt-5"
																				v-model="contact.name"
																				@keyup="validateName"  
																				:valid="valid.name" 
																				:error="error.name" 
																				required 
                                        alternative
                                        placeholder="Your name"
                                        addon-left-icon="ni ni-circle-08">
                            </base-input>
                            <base-input alternative
																				v-model="contact.email" 
																				@keyup="validateEmail"  
																				:valid="valid.email" 
																				:error="error.email" 
																				required 
                                        placeholder="Email address"
                                        addon-left-icon="ni ni-email-83">
                            </base-input>
                            <base-input class="mb-4">
                                    <textarea class="form-control form-control-alternative" name="name" rows="4"
																							v-model="contact.message"
                                              cols="80" placeholder="Type a message..."></textarea>
                            </base-input>
                            <base-button type="default" @click="submitMessage" round block size="lg">
                                Send Message
                            </base-button>
                        </card>
                    </div>
                </div>
            </div>
        </section>
        <section  v-if="''" class="section section-lg">
            <div class="container">
                <div class="row row-grid justify-content-center">
                    <div class="col-12 text-center">
                        <h2 class="display-3 mb-5">Industries and
                            <span class="text-success">Technologies</span>
                        </h2>
                        <div class="text-center">
                            <div class="row justify-content-center d-flex align-items-end">
                                <div class="col-lg-3 col-md-4 col-sm-6 p-5">
                                    <a href="#/transport_and_logistics">
                                        <img v-lazy="'img/theme/logistics_industry.svg'"
                                             class="img-fluid">
					Transport and Logistics
                                    </a>
                                </div>
                                <div class="col-lg-3 col-md-4 col-sm-6 p-5">
                                    <a href="#/it_and_communications">
                                        <img v-lazy="'img/theme/communication_industry.svg'"
                                             class="img-fluid">
					IT and Communications 
                                  </a>
                                </div>
                                <div class="col-lg-3 col-md-4 col-sm-6 p-5">
                                    <a href="#/consumer_goods_and_retail">
                                        <img v-lazy="'img/theme/retail_industry.svg'"
                                             class="img-fluid">
					Consumer Goods and Retail
                                    </a>
                                </div>
                                <div class="col-lg-3 col-md-4 col-sm-6 p-5">
                                    <a href="#/education_and_research">
                                        <img v-lazy="'img/theme/education_industry.svg'"
                                             class="img-fluid">
					Education and Research
                                    </a>
                                </div>
                                <div class="col-lg-3 col-md-4 col-sm-6 p-5">
                                    <a href="#/media_and_entertainment">
                                        <img v-lazy="'img/theme/media_industry.svg'"
                                             class="img-fluid">
					Media and Entertainment
                                    </a>
                                </div>
                                <div class="col-lg-3 col-md-4 col-sm-6 p-5">
                                    <a href="#/banking_and_finance">
                                        <img v-lazy="'img/theme/finance_industry.svg'"
                                             class="img-fluid">
					Banking and Financial
                                    </a>
                                </div>
                                <div class="col-lg-3 col-md-4 col-sm-6 p-5">
                                    <a href="#/manufacturing">
                                        <img v-lazy="'img/theme/manufacturing_industry.svg'"
                                             class="img-fluid">
					Manufacturing
                                    </a>
                                </div>
                                <div class="col-lg-3 col-md-4 col-sm-6 p-5">
                                    <a href="#/healthcare">
                                        <img v-lazy="'img/theme/healthcare_industry.svg'"
                                             class="img-fluid">
						Healthcare
                                    </a>
                                </div>
                                <div class="col-lg-3 col-md-4 col-sm-6 p-5">
                                    <a href="#/public_sector">
                                        <img v-lazy="'img/theme/public_sector_industry.svg'"
                                             class="img-fluid">
						Public sector
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

    </div>
</template>

<script>
export default {
  name: "home",
  components: {},
	data() {
		return {
			contact: {
				name: "",
				email: "",
				message: "",
			},
			valid: {
				name: null,
				email: null,
			},
			error: {
				name: null,
				email: null,
				submit: false,
			},
		}
	},
	methods: {
		validateName: function() {
			var valid = true
			if( this.contact.name.trim() ==="") {
				this.valid.name = false;
				this.error.name = "You must enter your name"
				valid = false;
			} else {
				this.valid.name = true;
				this.error.name = ""
				valid = true;
			}					
			return valid;
		},
		validateEmail: function() {
			var valid = true
			if( this.contact.email.trim() ==="") {
				this.valid.email = false;
				this.error.email = "You must enter your email"
				valid = false;
			} else {
				this.valid.email = true;
				this.error.email = ""
				valid = true;
			}					
			return valid;
		},
		checkAllValidations: function () {
			var validkeys = Object.keys(this.valid);
			for (var i = 0 ; i < validkeys.length; i++) {
				if (!this.valid[validkeys[i]] || this.valid[validkeys[i]] == null) {
					this.error.submit = true;
					return false;	
				}
			}
			this.error.submit=false;
			return true;
		},
		submitMessage: function() {
			var valid = this.checkAllValidations()
			if (valid) {
				this.$router.push({ 
					name: "thank_you_for_contacting",
					params: { messageType: "contact_message", message: this.contact},
				});
			}
		},
	}
};
</script>

<style>
	.yes,
	.no,
	.sometimes {
		vertical-align: middle !important;	
		text-align: center;
	}
	.yes {
		font-weight: 900 !important;
		color: #2dce89 !important;
	}
	.no {
		color:#f5365c; 
	}
	.sometimes {
		color: #fb6340;
	}
	thead tr th {
		color: #fff;
	}
</style>
